interface SpinnerProps {
  fullscreen?: boolean
  label?: string
}

export function Spinner({ fullscreen, label = 'Lade…' }: SpinnerProps) {
  const content = (
    <div className="spinner" role="status" aria-label={label}>
      <span className="spinner-dot" />
      <span className="spinner-dot" />
      <span className="spinner-dot" />
    </div>
  )
  if (fullscreen) return <div className="spinner-wrap">{content}</div>
  return content
}
